import { useTranslation } from "react-i18next";
import { CalendarCheck, Car, FileCheck2, MapPin } from "lucide-react";

const STEPS = [
  { icon: CalendarCheck, title: "Choose your plan", text: "Daily, weekly or monthly — pick dates and how you'd like your car." },
  { icon: Car, title: "Select your car", text: "Plenty of models to choose from, real rates including VAT, with a zero-deposit option." },
  { icon: FileCheck2, title: "Verify documents", text: "After you book, not before. Upload from your phone in about two minutes." },
  { icon: MapPin, title: "Delivered or picked up", text: "To your door in as little as 4 hours, or collect at any of our 14 branches." },
];

export const HowItWorks = () => {
  const { t } = useTranslation();
  return (
    <section className="bg-white border-b border-[#E2E8F0]" data-testid="how-it-works">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
        <div className="promo-stripe mb-6">
          <h2 className="heading-upper text-xl text-[#144733]">{t("Rent in four easy steps")}</h2>
          <p className="text-sm text-[#57685e] mt-1">{t("From search to keys — most customers finish in under three minutes.")}</p>
        </div>
        <div className="flex lg:grid lg:grid-cols-4 gap-4 overflow-x-auto snap-x pb-2">
          {STEPS.map((s, i) => (
            <div key={s.title} className="min-w-[240px] lg:min-w-0 snap-start bg-[#fafcfa] border border-[#e2ebe4] rounded-2xl p-5 relative" data-testid={`how-step-${i + 1}`}>
              <span className="absolute top-4 right-4 text-3xl font-bold text-[#e2ebe4]">{i + 1}</span>
              <s.icon className="w-7 h-7 text-[#009900] mb-3" />
              <h3 className="font-bold text-sm text-[#0F1E17]">{t(s.title)}</h3>
              <p className="text-xs text-[#57685e] mt-1 leading-relaxed">{t(s.text)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
